"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasText = void 0;

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.string.link");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _Fonts = require("../../../../Assets/Fonts");

var _Helpers = require("../../../Helpers");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _resizer = require("../../../../Utils/resizer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    line-height: 1.35em;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  line-height: 1.35em;\n  margin-bottom: 10px;\n  display: initial;\n  background-image: linear-gradient(to bottom, transparent 0, ", " 2px, transparent 0);\n  background-position: bottom;\n  background-size: 1px 5px;\n  background-repeat: repeat-x;\n  transition: all .3s;\n  &:hover {\n    opacity: .6;\n  }\n  ", "\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    line-height: 1.35em;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto 10px auto;\n    max-width: calc(100% - 40px);\n    ", "\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  line-height: ", " \n  margin-bottom: 25px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n    width: 100%;\n    padding: 0;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: auto;\n    margin: 20px 0;\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  object-fit: contain;\n  object-position: left;\n  max-width: ", "\n  max-height: ", "\n  margin: ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CanvasText = function CanvasText(props) {
  var disclaimer = props.disclaimer,
      unit = props.unit;
  var resized_logo = unit.logo ? (0, _resizer.resize)(unit.logo, {
    // slightly oversize to avoid fuzziness
    width: 400,
    isDisplayAd: true
  }) : "";
  var isSlideshowWithCaption = unit.layout === "slideshow" && (0, _compact2.default)((0, _map2.default)(unit.assets, "caption")).length;
  var hasDisclaimer = unit.layout !== "overflow" && !isSlideshowWithCaption;
  return _react.default.createElement(CanvasInner, {
    layout: unit.layout,
    isSlideshowWithCaption: true
  }, _react.default.createElement("div", null, _react.default.createElement(Logo, {
    layout: unit.layout,
    src: resized_logo
  }), _react.default.createElement(Headline, {
    layout: unit.layout
  }, unit.headline), _react.default.createElement(Link, {
    layout: unit.layout
  }, unit.link.text)), hasDisclaimer && disclaimer);
};

exports.CanvasText = CanvasText;
var Div = _styledComponents.default.div;
var Img = _styledComponents.default.img;
var Logo = Img(_templateObject(), function (props) {
  return props.layout === "overlay" ? "300px;" : "250px;";
}, function (props) {
  return props.layout === "overlay" ? "100px;" : "90px;";
}, function (props) {
  return props.layout === "overlay" ? "60px auto;" : "20px 0 50px 0;";
}, function (props) {
  return _Helpers.pMedia.md(_templateObject2(), props.layout === "overlay" && "max-width: calc(100% - 60px);\n       margin: 15px auto;\n    ");
});
var CanvasInner = Div(_templateObject3(), function (props) {
  return props.layout === "overlay" || props.isSlideshowWithCaption ? "space-around;" : "space-between;";
}, function (props) {
  return props.layout === "overlay" && "text-align: center;\n        color: #fff;\n        max-width: 500px;";
}, function (props) {
  return _Helpers.pMedia.md(_templateObject4(), props.layout === "slideshow" && "width: 100%;");
}, _Helpers.pMedia.sm(_templateObject5()));
var Headline = Div(_templateObject6(), function (props) {
  return props.layout === "overlay" ? (0, _Fonts.garamond)("s23") : (0, _Fonts.garamond)("s40");
}, function (props) {
  return props.layout === "overlay" ? "1.35em;" : "1.1em;";
}, function (props) {
  return _Helpers.pMedia.lg(_templateObject7(), props.layout !== "overlay" && (0, _Fonts.garamond)("s23"));
}, function (props) {
  return _Helpers.pMedia.sm(_templateObject8(), props.layout !== "overlay" && "margin-left: 0;");
}, function (props) {
  return _Helpers.pMedia.xs(_templateObject9(), props.layout === "overlay" && (0, _Fonts.garamond)("s17"));
});
var Link = Div(_templateObject10(), (0, _Fonts.garamond)("s23"), function (props) {
  return props.layout === "overlay" ? "#FFF" : "#000";
}, function (props) {
  return _Helpers.pMedia.lg(_templateObject11(), props.layout !== "overlay" && (0, _Fonts.garamond)("s17"));
}, _Helpers.pMedia.md(_templateObject12(), (0, _Fonts.garamond)("s17")));
//# sourceMappingURL=CanvasText.js.map